import posthog from "posthog-js";

let isInitialized = false;

export function initPostHog(apiKey, host, user) {
  if (process.env.NODE_ENV !== "production") return;
  if (typeof window === "undefined" || !apiKey) return;

  if (!isInitialized) {
    posthog.init(apiKey, {
      api_host: host || "https://g.hoppyapps.com",
      ui_host: "https://us.posthog.com",
      defaults: "2026-05-30",
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
    });
    isInitialized = true;
  }

  if (user && (user.myShopifyDomain || user.storeId)) {
    const distinctId = user.myShopifyDomain || user.storeId;
    posthog.identify(distinctId, {
      email: user.email,
      name: user.name,
      shopify_plan: user.shopifyPlan,
      myshopify_domain: user.myShopifyDomain,
      store_id: user.storeId,
    });
  }
}

/**
 * Capture client-side event in PostHog
 * @param {string} event - Event name (will automatically be prefixed with hoppy_trust_badges_)
 * @param {object} properties - Additional event properties
 */
export function captureClientEvent(event, properties = {}) {
  if (process.env.NODE_ENV !== "production") return;
  if (typeof window !== "undefined") {
    try {
      const eventName = event.startsWith("hoppy_trust_badges_")
        ? event
        : `hoppy_trust_badges_${event}`;
      posthog.capture(eventName, properties);
    } catch (err) {
      console.error("Error capturing PostHog client event:", err);
    }
  }
}
